export const HERO_NUMBER_ANIMATION_DELAY = 0.95;
export const HERO_TEXT_ANIMATION_DELAY = 0.46;
export const COVER_ANIMATION_DELAY = 1.1;
